module.exports = __webpack_public_path__ + "img/Caret down.ad25b7e5.svg";